module.exports = __webpack_public_path__ + "img/7.487f077c.jpg";